export const xToken = "tGCKLX4BiitGilbyi6SVyfA0vVPsllc8"

// 类似url: `/admin/sys/role/getRoleDetail/${id}`,  这种后面拼接id 的一定要使用模板字符串
// -- dev接口生成调试区 --
const devApiFileMap = {
	
}
// -- 结束
export const devApiMap = Object.keys(devApiFileMap).reduce((p, n) => {
    p = { ...p, ...devApiFileMap[n] }
    return p
}, {})

export const devMatchApiMap = Object.keys(devApiFileMap).reduce((p, n) => {
    Object.keys(devApiFileMap[n]).forEach((v) => {
        if (v.includes('/${')) {
            p[`${v.split("/${")[0]}/*`] = devApiFileMap[n][v]
        }
    })
    return p
}, {})
